import React, { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useMessagingAccessToken from '../hooks/useMessagingAccessToken';

export const MessagingTokenContext = createContext();

// Do not get the token immediately on load of my-icsc because it creates
// a user in Twilio. Twilio charges per "active" user.
const MessagingTokenProvider = ({ children }) => {
    const [accessToken, setAccessToken] = useState();
    const [isEnabled, setIsEnabled] = useState(false);
    const { data, error } = useMessagingAccessToken({ isEnabled });

    useEffect(() => {
        if (!data) return;
        setAccessToken(data);
    }, [data]);

    // calling this enables and triggers the query for the messaging token
    // which triggers the creation of the Twilio Conversations client in ConversationsClientProvider
    const getMessagingToken = async () => {
        setIsEnabled(true);
    };

    return (
        <MessagingTokenContext.Provider value={{ accessToken, error, getMessagingToken }}>
            {children}
        </MessagingTokenContext.Provider>
    );
};

MessagingTokenProvider.propTypes = {
    children: PropTypes.any,
};

export default MessagingTokenProvider;
